import {Trans, useTranslation} from "react-i18next";
import {LegalTextsState} from "../../context/LegalTextsContext.tsx";

const LegalModals = () => {

    const {t} = useTranslation();
    const {setIsPaymentTermsOpen, setIsPrivacyPolicyOpen} = LegalTextsState();

    return (
        <>
            <div>
                <p>
                    <Trans>
                        {t('additional_text_2')}&nbsp;
                        <span className={`info-link`}
                              onClick={() => setIsPaymentTermsOpen(true)}>
                            <strong>{t('with_payment_terms')}</strong>
                        </span>&nbsp;
                        <span>{t('and')}</span>&nbsp;
                        <span className={`info-link`}
                              onClick={() => setIsPrivacyPolicyOpen(true)}>
                            <strong>{t('with_privacy_policy')}</strong>
                        </span>.
                    </Trans>
                </p>
            </div>
        </>
    )
}

export default LegalModals;
